import styled from "styled-components";
import { getBackgroundColor, ValueColumnProps } from "../styles";

export const ValueColumn = styled.td<ValueColumnProps>`
  width: ${props => props.width + "px"};
  min-width: ${props => props.width + "px"};
  height: 23px;
  border: 0.5px solid #808080;
  background-color: ${({ theme, disabled, red }) =>
    disabled ? theme.lightBlueBackground : getBackgroundColor({ red })
  };
  
  input {
    width: 100%;
    height: 100%;
    border: none;
    color: #333333;
    text-align: center;
    background: transparent;
  }
    
  input[type="checkbox"] {
    margin-top: 0;
  }
`;

export const StyledInput = styled.input<{ isZero?: boolean, bold?: boolean }>`
  color: ${props => props.isZero ? "#FB1900 !important" : "initial"};
  font-weight: ${props => props.bold ? "bold" : "normal"};
`;

export const StyledCheckbox = styled.input`
  display: block;
  margin: 0 auto;
  width: 14px !important;
  height: 14px !important;
`;
